import {
    SET_LANGUAGE,
    SET_PAGE,
    SET_CURRENT_LINK,
    SET_CURRENCY,
    SET_MODULEDATA,
    HANDLE_GLOBAL_LNG_DATA,
    HANDLE_MODULE_LNG_DATA
} from '../mutation-types';
import util from '@/common/util';
import { localLanguage, localCurrency } from '@/globalization/localData';
import {
    defaultLngCode,
    defaultCurrencyCode,
    defaultCurrencySymbol
} from '@/globalization/constant.js';
import AllLang from '../../common/translate/googleTranslatePlugin/data.js';

const isArray_Object = function (value) {
    return (
        Object.prototype.toString.call(value) == '[object Object]' ||
        Array.isArray(value)
    );
};
const isEmptyObject = function (value) {
    Object.keys(value).length <= 0;
};

function mergeData(to, from, getSysLanguageCb) {
    let keys = Object.keys(from);
    let key,
        len = keys.length;
    for (let i = 0; i < len; i++) {
        key = keys[i];
        let toVal = to[key];
        let fromVal = getSysLanguageCb(toVal, from[key]);
        let fromValIsObj = isArray_Object(fromVal);
        let toValIsObj = isArray_Object(toVal);
        if (fromValIsObj && toValIsObj) {
            mergeData(toVal, fromVal, getSysLanguageCb);
            continue;
        }
        if (fromVal == undefined) {
            continue;
        }
        if (toValIsObj && !fromValIsObj) {
            console.info('Language mixing will affect the data structure');
        }
        to[key] = from[key];
    }
}

const fetcherSysLanguageModules = {
    'md-footer': true,
    'md-header': true
};

function mergeLanguageToData(name, data, language, lng) {
    // if (!lng) {
    //     lng = globalization.lng();
    // }
    if (fetcherSysLanguageModules[name]) {
        mergeLanguageToData_fetcher(data, language, lng);
    } else {
        mergeLanguageToData_data(data, language, lng);
    }
    return data;
}
//国际化数据全部都在与data平级的sysLanguage中
function mergeLanguageToData_data(data, language, lng) {
    if (!language || !Object.keys(language).length) {
        return;
    }
    let languageObj = language[lng];
    if (!languageObj) {
        //如果没有language属性
        languageObj = language[defaultLngCode];
    }
    if (!languageObj) {
        return;
    }
    mergeData(data, languageObj, (_, fromVal) => fromVal);
}
//国际化数据部分存储在data中

function mergeLanguageToData_fetcher(data, language, lng) {
    const mergeLanguage = fullSysLanguage => {
        let languageObj =
            fullSysLanguage[lng] ?? fullSysLanguage[defaultLngCode];
        if (languageObj && !isEmptyObject(languageObj)) {
            mergeData(data, languageObj, (_, fromVal) => fromVal);
        }
    };
    if (language && !isEmptyObject(language)) {
        mergeLanguage(language);
    }
    if (data.sysLanguage && !isEmptyObject(data.sysLanguage)) {
        mergeLanguage(data.sysLanguage);
    }
}

const store = {
    namespaced: true,
    state: () => ({
        currentLanguage: defaultLngCode,
        currentLink: '',
        currency: {
            symbol: defaultCurrencySymbol,
            abbr: defaultCurrencyCode
        },
        page: {},
        moduleData: []
    }),
    getters: {
        hasEmailLead(state) {
            var globalData = state.page;
            return (
                globalData &&
                globalData.site &&
                (globalData.site.emailLead ||
                    typeof globalData.site.emailLead === 'undefined')
            );
        },
        // chime | googlePlugin
        translatorType(state) {
            return state.page.translatorType;
        },
        languageMenus(state, getters) {
            switch (getters.translatorType) {
                case 'chime':
                    return state.page.sysLanguageList.map(l => {
                        return {
                            name: l.language,
                            label: l.nativeName,
                            img: l.icon
                        };
                    });
                case 'googlePlugin':
                    return state.page.language.options.map(name => {
                        let r = AllLang.find(v => v.name === name);
                        return {
                            name: name,
                            label: r.label.toUpperCase(),
                            img: r.img
                        };
                    });
                default:
                    return [];
            }
        },
        showCurrency(state) {
            let { openMultilingual, siteCurrencyList } = state.page || {};
            return (
                openMultilingual &&
                siteCurrencyList &&
                siteCurrencyList.length > 1
            );
        },
        currencyList(state) {
            return state.page.siteCurrencyList || [];
        },
        processedGlobalData(state) {
            return {
                ...(state.page || {}),
                currencySymbol: state.currency.symbol
            };
        }
    },
    mutations: {
        [SET_LANGUAGE](state, lang) {
            state.currentLanguage = lang;
        },
        [SET_CURRENCY](state, currencyObj) {
            state.currency.name = currencyObj.name;
            state.currency.abbr = currencyObj.abbr;
            state.currency.symbol = currencyObj.symbol;
            localCurrency.set(currencyObj);
        },
        [SET_PAGE](state, page) {
            // 全局数据不应该被修改
            state.page = Object.freeze(page) || {};
        },
        [SET_CURRENT_LINK](state, currentLink) {
            state.currentLink = currentLink;
        },
        [SET_MODULEDATA](state, moduleData) {
            state.moduleData = moduleData || [];
        },
        [HANDLE_GLOBAL_LNG_DATA](state) {
            let lng = state.currentLanguage;
            for (let k in state.page) {
                const v = state.page[k];
                if (!v || !v.sysLanguage) {
                    continue;
                }
                mergeLanguageToData(null, v, v.sysLanguage, lng);
            }
        },
        [HANDLE_MODULE_LNG_DATA](state) {
            let lng = state.currentLanguage;
            state.moduleData.forEach(module => {
                if (!module.data) {
                    return;
                }
                mergeLanguageToData(
                    module.name,
                    module.data,
                    module.sysLanguage,
                    lng
                );
            });
        }
    },
    actions: {
        // 切换语言, 会返回是否真的应用了
        setLanguage({ commit, state, getters }, lang) {
            if (
                getters.translatorType &&
                state.currentLanguage !== lang &&
                getters.languageMenus.find(item => item.name == lang)
            ) {
                commit(SET_LANGUAGE, lang);
                if (getters.translatorType === 'chime') {
                    localLanguage.set(lang);
                    return Promise.resolve({ changed: true, isChime: true });
                } else if (getters.translatorType === 'googlePlugin') {
                    util.setCookie('chimetrans_gt', lang);
                    return Promise.resolve({ changed: true, isChime: false });
                }
            }
            return Promise.resolve({ changed: false });
        },
        selectCurrency({ commit }, payload) {
            commit(SET_CURRENCY, payload);
            window.location.reload();
        },
        // 根据cookie初始化currentLanguage
        initCurrentLang({ commit, state, getters }) {
            var lang =
                getters.translatorType === 'chime'
                    ? localLanguage.get()
                    : util.getCookie('chimetrans_gt') ||
                      util.getCookie('chimetrans');
            console.log(lang, getters.languageMenus);
            if (
                getters.translatorType &&
                getters.languageMenus.find(item => item.name == lang)
            ) {
                commit(SET_LANGUAGE, lang);
            }
        },
        initCurrency({ commit, state, getters }) {
            if (!getters.showCurrency) {
                return;
            }
            const { siteCurrencyList } = state.page;
            let abbr = localCurrency.get();
            if (!abbr) {
                return localCurrency.reset();
            }
            for (let i = 0; i < siteCurrencyList.length; i++) {
                if (siteCurrencyList[i].abbr == abbr) {
                    return commit(SET_CURRENCY, siteCurrencyList[i]);
                }
            }
            localCurrency.reset();
            window.location.reload();
        }
    }
};

export default store;
